
<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'
import Remodal from './Remodal.vue'
import Subscribe from './Subscribe.vue'
import BookIn from './BookIn.vue'
import bPagination from 'bootstrap-vue/es/components/pagination/pagination'


const showPages = 10

export default {
  name: 'BookCase',
  props: ["list"],
  data () {
    return {
        showPages: showPages
    }
  },
  methods: {
    ...user,
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  },
  components: {
    Remodal,
    Subscribe,
    BookIn,
    bPagination
  }
}
</script>

<template>
  <div>
    <div class="book_th_wrap">
        <a><div class="book_th"></div></a>
        <a><div class="book_th_blue"></div></a>
        <a><div class="book_th_list"></div></a>
        <a><div class="book_th_list_blue"></div></a>
        <div class="custom_select_word">排序</div>
        <div class="custom-select">
            <select>
            <option value="1">依字數少→多</option>
            <option value="2">依字數多→少</option>
            <option value="3">依個人星等</option>
            <option value="2">依購買日期</option>
            </select>
        </div>
    </div>
    <div class="book_block_wrap">
    <div class=" bookcast_list_wrap" v-if="list && list.Books.length">
        <div class="col-md-12">
            <div class="abgne-yahoo-carousel">
                <div class="frame leaderboard">
                    <ul>
                        <book-in :book="book" :display="'block'" v-for="(book, idx) of list.Books" :key="idx"></book-in>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <b-pagination v-if="list && list.Books.length" size="md" :total-rows="list.Books.length" v-model="list.Page" :per-page="showPages" :first-text="''" :last-text="''"></b-pagination>
    </div>
    <div class="book_list_wrap" style="display:none">
    <div class=" bookcast_list_wrap" v-if="list && list.Books.length">
        <div class="bookcast_list_box">
            <ul>
                <book-in :book="book" :display="'list'" v-for="(book, idx) of list.Books" :key="idx"></book-in>
            </ul>
        </div>
    </div>
    <b-pagination v-if="list && list.Books.length" size="md" :total-rows="list.Books.length" v-model="list.Page" :per-page="showPages" :first-text="''" :last-text="''"></b-pagination>
    </div>
  </div>
</template>


// WEBPACK FOOTER //
// src/BookCase.vue